import(/* webpackMode: "eager" */ "/codebuild/output/src2352516833/src/unimig_frontend/components/blogs/article.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2352516833/src/unimig_frontend/components/blogs/ArticleSectionClient.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2352516833/src/unimig_frontend/components/blogs/BlogSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2352516833/src/unimig_frontend/components/blogs/Content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2352516833/src/unimig_frontend/components/blogs/RelatedArticles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/codebuild/output/src2352516833/src/unimig_frontend/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2352516833/src/unimig_frontend/components/ui/BreadCrumb.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2352516833/src/unimig_frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2352516833/src/unimig_frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2352516833/src/unimig_frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
